import type { Tracker } from '@archipro-website/tracker';

interface TrackTileMediaProps {
    itemID: number;
    itemType:
        | 'ProductTile'
        | 'ProfessionalTile'
        | 'ProjectTile'
        | 'ArticleTile';
    itemName: string;
}

/**
 * Track the `TileMediaDetailClick` event. Triggers when a user clicks on a tile
 * to go to the detail page.
 */
export function trackTileMediaDetailClick(
    tracker: Tracker,
    props: TrackTileMediaProps,
) {
    void tracker.log('TileMediaDetailClick', {
        url: new URL(window.location.href),
        label: props.itemName,
        data: {
            LibraryItemID: props.itemID,
            content_ids: [`${props.itemType}_${props.itemID}`],
            content_type: props.itemType,
        },
        targetTracker: ['archiproTracker', 'ga4Tracker'],
    });
}
